var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useEffect, useState } from 'react';
import { useFirebase } from '@web/firebase';
import { useAccount } from '../../../ModuleAccount';
import { useAuth } from '../../../ModuleAuth';
import { Roles } from '../../../ModuleApp';
import fileSize from 'filesize';
import chroma from 'chroma-js';
import { styled } from '@web/theme';
var storageQuota = 1024 * 1024 * 1024 * 5;
export var StorageSize = memo(function () {
    var instance = useFirebase().instance;
    var user = useAuth().auth.user;
    var account = useAccount().account;
    var _a = useState(0), bytes = _a[0], setBytes = _a[1];
    useEffect(function () {
        if (account === null || account === void 0 ? void 0 : account.uid) {
            instance === null || instance === void 0 ? void 0 : instance.pageDrive.listAll().then(function (res) {
                var size = 0;
                res.prefixes.forEach(function (folderRef) {
                    folderRef.listAll()
                        .then(function (items) {
                        items.items.forEach(function (itemRef) {
                            itemRef.getMetadata()
                                .then(function (item) { return setBytes(function (state) { return state + item.size; }); });
                        });
                    })
                        .catch(function (err) { return console.log('e2:', err); });
                });
            }).catch(function (err) { return console.log('e1:', err); });
            instance === null || instance === void 0 ? void 0 : instance.blockDrive.listAll().then(function (res) {
                var size = 0;
                res.prefixes.forEach(function (folderRef) {
                    folderRef.listAll()
                        .then(function (items) {
                        items.items.forEach(function (itemRef) {
                            itemRef.getMetadata()
                                .then(function (item) { return setBytes(function (state) { return state + item.size; }); });
                        });
                    })
                        .catch(function (err) { return console.log('e2:', err); });
                });
            }).catch(function (err) { return console.log('e1:', err); });
        }
    }, [instance, account]);
    if (!(user === null || user === void 0 ? void 0 : user.uid) || (account === null || account === void 0 ? void 0 : account.role) !== Roles.admin)
        return null;
    return (React.createElement(Panel, null,
        React.createElement(StorageProgress, { value: bytes, max: storageQuota })));
});
var StorageProgress = memo(function (_a) {
    var value = _a.value, max = _a.max;
    return React.createElement(React.Fragment, null,
        React.createElement(Progress, null,
            React.createElement(Value, { style: { width: value / (max / 100) + "%" } })),
        React.createElement(Info, null,
            fileSize(value),
            " / ",
            fileSize(max)));
});
var Panel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-top: .5rem;\n\twidth: 145px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tjustify-content: center;\n"], ["\n\tmargin-top: .5rem;\n\twidth: 145px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tjustify-content: center;\n"])));
var Info = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 0.7em;\n"], ["\n\tfont-size: 0.7em;\n"])));
var Progress = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 4px;\n\tbackground-color: ", ";\n\tborder-radius: 2rem;\n"], ["\n\twidth: 100%;\n\theight: 4px;\n\tbackground-color: ", ";\n\tborder-radius: 2rem;\n"])), function (_a) {
    var theme = _a.theme;
    return chroma(theme.page.txt).alpha(.1).hex();
});
var Value = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\theight: 100%;\n\tbackground-color: ", ";\n\tborder-radius: 2rem;\n"], ["\n\theight: 100%;\n\tbackground-color: ", ";\n\tborder-radius: 2rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.page.txt;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
